import { useEffect } from 'react';

import AOS from 'aos';
import 'swiper/css';

// routes
import Routes from './routes/Routes';
import { HelmetProvider } from 'react-helmet-async';

// helpers
import { configureFakeBackend } from './helpers';
import './assets/scss/theme.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const App = () => {
    useEffect(() => {
        AOS.init();
    }, []);

    configureFakeBackend()
    return (<>
        <HelmetProvider>
            <Routes />
        </HelmetProvider>
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
    </>)
};

export default App;
